module.exports = __webpack_public_path__ + "images/assets/e54b02cb6ddac314b639d5828b837cde.svg";